import { useMutation } from "@apollo/client";
import mutations from "Shared/mutations";
import { downloadS3File } from "Modules/S3Downloads";
import { GenerateBatchOnboardUrlMutation, GenerateBatchOnboardUrlMutationVariables } from "generated/graphql";

export const useDownloadBatchOnBoard = () => {
  const [generateBatchOnboardUrlFn] = useMutation<
    GenerateBatchOnboardUrlMutation, GenerateBatchOnboardUrlMutationVariables
  >(mutations.GENERATE_BATCH_ONBOARD_URL);

  const downloadBatchOnboardById = (batchOnboardId: string) => {
    return async () => {
      const result = await generateBatchOnboardUrlFn({
        variables: { batchOnboardId },
      });

      const batchOnboardUrl = result?.data?.generateBatchOnboardUrl?.batchOnboardUrl;

      !!batchOnboardUrl && downloadS3File(batchOnboardUrl);
    };
  };

  return {
    downloadBatchOnboardById,
  };
};
